angular.module('dnecom')
    .controller('StoreCurrencySettingsController', ["$scope", function ($scope) {
    }]);
